import packageTypes from './types';

export const initialStates = {
	v2_packages: null,
	v1_packages: null,
	updatedStatus: null,
	create: null,
	update: null,
	bestSelling: [],
};

const packageReducers = (state = initialStates, action) => {
	switch (action.type) {
		case packageTypes.V2_FETCH.SUCCESS: {
			return { ...state, v2_packages: action?.payload?.data };
		}

		case packageTypes.V2_FETCH.CLEAR: {
			return { ...state, v2_packages: null };
		}

		case packageTypes.V1_FETCH.SUCCESS: {
			return { ...state, v1_packages: action?.payload?.data };
		}

		case packageTypes.V1_FETCH.CLEAR: {
			return { ...state, v1_packages: null };
		}

		case packageTypes.UPDATE_STATUS.SUCCESS: {
			return { ...state, updatedStatus: action?.payload };
		}

		case packageTypes.UPDATE_STATUS.CLEAR: {
			return { ...state, updatedStatus: null };
		}

		case packageTypes.CREATE.SUCCESS: {
			return { ...state, create: action?.payload };
		}

		case packageTypes.CREATE.CLEAR: {
			return { ...state, create: null };
		}

		case packageTypes.UPDATE.SUCCESS: {
			return { ...state, update: action?.payload };
		}

		case packageTypes.UPDATE.CLEAR: {
			return { ...state, update: null };
		}

		case packageTypes.BEST_SELLING.SUCCESS: {
			return { ...state, bestSelling: [...action?.payload] };
		}

		default:
			return state;
	}
};

export default packageReducers;
